var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],staticClass:"qr-img-smart",attrs:{"data-src":_vm.qrCodeSrc || '/img/1x1.png',"alt":"QR code","width":_vm.size,"height":_vm.size,"data-not-lazy":""}})}
var staticRenderFns = []

export { render, staticRenderFns }